import React, {useState} from 'react';
import {Button, Card, CardHeader, Col, Modal, Progress, Row, Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {alert_strings} from "../translations/alert_translations";
import {common_strings} from "../translations/common_translations";
import localeHelpers from "../helpers/LocaleHelper";
import NotificationItem from "./Lists/NotificationItem";
import {resource_strings} from "../translations/resource_translations";
import Badge from "reactstrap/es/Badge";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const NotificationComponent = (props) => {
    const [visible, setVisible] = useState(props.showError === true);

    const onDismiss = () => setVisible(false);

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    localize();

    return (
        <Card className="shadow" style={{marginBottom: 20}}>
            <CardHeader className="border-0">
                <Row className="align-items-center">
                    <div className="col">
                        <h3 className="mb-0">{resourceStrings.notifications} <Badge className="" color="success">{props.totalNotifications}</Badge></h3>
                    </div>
                    <div className="col text-right">
                        {props.seeAll &&
                        <Button
                            color="primary"
                            onClick={e => props.seeAll()}
                            size="sm"
                        >
                            {commonStrings.see_all}
                        </Button>
                        }
                    </div>
                </Row>
            </CardHeader>
            {props.items && props.items.length > 0 ?
                (<div style={{width: "100%"}}>

                    {props.items.map((item, index) =>
                        <NotificationItem
                            key={index}
                            item={item}
                            onNotificationSelected={e => props.onNotificationSelected(e, item)}
                        />)}

                </div>) : (
                    <div style={{width: "100%"}} className="text-center text-gray">
                        <hr/>
                        <small><span className="mb-4">{resourceStrings.notification_expl}</span></small></div>
                )
            }
        </Card>
    );

};

export default NotificationComponent;